module.exports = __webpack_public_path__ + "img/文本图形2.75860573.svg";